import { FabricObject } from "./FabricObject";
export class FabricPath extends FabricObject {
    constructor(path, args) {
        super(args);
        this.path = path;
        const keys = Object.keys(args);
        keys.forEach((key) => this[key] = args[key]);
    }
    setCoords() {
        this.dirty = true;
    }
    draw(ctx, scale) {
        let pathStr;
        if (Array.isArray(this.path)) {
            const path_arr = this.path;
            pathStr = path_arr.reduce((prev, item) => {
                const cmd = item.shift();
                return prev + cmd + item;
            }, "");
        }
        else {
            pathStr = this.path;
        }
        const path = new Path2D(pathStr);
        let c = "";
        if (typeof this.color === "string" && this.color[0] === "#") {
            let rgb = this.color;
            if (rgb.length < 7)
                rgb = (rgb + "000000").substring(0, 7);
            c = rgb + d2h(this.opacity * 255);
        }
        else {
            const reg = this.color.split(/(\d+)/);
            const r = reg[1];
            const g = reg[3];
            const b = reg[5];
            c = `rgba( ${r}, ${g}, ${b}, ${this.opacity})`;
        }
        path.color = c;
        path.opacity = this.opacity;
        ctx.fillStyle = c;
        ctx.fill(path);
    }
}
function d2h(d) {
    return (d / 256 + 1 / 512).toString(16).substring(2, 4);
}
//# sourceMappingURL=FabricPath.js.map